






















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'product-list-toolbar',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: true}) readonly position: string;
  @Prop() readonly catalogData: object;

  private get totalItemCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private get itemsViewed(): number {
    return this.$store.getters[`${this.dataSource}/currentPage`] > 1 ? (this.$store.getters[`${this.dataSource}/pageSize`] * (this.$store.getters[`${this.dataSource}/currentPage`] - 1) + this.$store.getters[`${this.dataSource}/productList`].length) : this.$store.getters[`${this.dataSource}/productList`].length;
  }
}
